export default [{
        icon: 'nc-icon nc-layout-11',
        collapsed: false,
        name: 'Home',
        path: '/adminHome'
    },
    {
        name: 'Users',
        icon: 'nc-icon nc-circle-10',
        collapsed: true,
        children: [{
                name: 'List',
                path: '/usersList'
            },
            {
                name: 'Add',
                path: '/AddUsers'
            }
        ]
    },
    {
        name: 'Daily Weight',
        icon: 'nc-icon nc-box',
        children: [{
                name: 'Add New',
                path: '/dwAdd'
            },
            {
                name: 'History',
                path: '/dwList'
            }
        ]
    },
    {
        name: 'Market Data',
        icon: 'nc-icon nc-vector',
        children: [{
                name: 'Add New',
                path: '/mdAdd'
            },
            {
                name: 'History',
                path: '/mdList'
            }
        ]
    },
]